module.exports = __webpack_public_path__ + "static/img/show-house.8229fc8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/show-house.jpg
// module id = 3+/C
// module chunks = 78